import React from 'react';
import axios from 'axios';
import {PAYD_API_URL} from './env';
import useAuthStore from '../store/auth';

export const http = axios.create({
	baseURL: PAYD_API_URL,
	withCredentials: true,
});

http.interceptors.request.use(
	config => {
		try {
			let token = useAuthStore.getState()?.token;
			if (!token) {
				const xAuth = localStorage.getItem('x-auth');
				if (xAuth) {
					const parsedXAuth = JSON.parse(xAuth);
					token = parsedXAuth?.state?.token;
				}
			}
			if (token && token !== 'session_active') {
				config.headers['Authorization'] = `Bearer ${token}`;
			}
		} catch (e) {
			//
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

export const AxiosContext = React.createContext(http);